export class TreeChecklistNode {
    children: TreeChecklistNode[];
    id: string;
    title: string;
}

export class TreeChecklistFlatNode {
    id: string;
    title: string;
    level: number;
    expandable: boolean;
}
